import { VariantProps, cva } from 'cva';

interface Props extends VariantProps<typeof badge> {
  label: React.ReactNode;
}

const badge = cva({
  base: [
    'inline-flex group relative isolate w-fit transform-gpu overflow-hidden rounded-md px-1.5 translate-y-[0.5px]',
    'after:absolute after:inset-0'
  ],

  variants: {
    intent: {
      primary: [
        'shadow-[inset_0px_1px_0px_theme(colors.white/12%),inset_0px_-1px_0px_theme(colors.white/4%),0px_2px_2px_-1px_rgb(66,67,77,0.24),0px_4px_4px_-2px_rgb(66,67,77,0.12)] bg-newGray-900',
        'after:bg-[linear-gradient(theme(colors.white/24%),theme(colors.white/16%)_46%,theme(colors.white/12%)_54%,theme(colors.white/8%))] after:opacity-60',
        '[--text-color:#FFFFFF]'
      ],
      skyBlue: [
        'bg-[#38D3FD] [--text-color:theme(colors.newGray.950)] shadow-[inset_0px_1px_0px_theme(colors.white/26%)]',
        'after:bg-[linear-gradient(theme(colors.white/24%),theme(colors.white/24%)_46%,theme(colors.white/12%)_54%,theme(colors.white/8%))]'
      ],
      yellow: [
        'bg-[#FDE047] [--text-color:theme(colors.newGray.950)] shadow-[inset_0px_1px_0px_theme(colors.white/26%)]',
        'after:bg-[linear-gradient(theme(colors.white/24%),theme(colors.white/24%)_46%,theme(colors.white/12%)_54%,theme(colors.white/8%))]'
      ],
      purple: [
        'bg-[#6C47FF] [--text-color:theme(colors.white)] shadow-[inset_0px_1px_0px_theme(colors.white/26%)] [text-shadow:0px_1px_1px_theme(colors.black/10%)]',
        'after:bg-[linear-gradient(theme(colors.white/10%),theme(colors.white/10%)_46%,theme(colors.white/4%)_54%,theme(colors.white/2%))]'
      ]
    }
  }
});

export function Badge({ label, intent = 'primary' }: Props) {
  return (
    <div className={badge({ intent })}>
      <span className="relative z-10 whitespace-nowrap text-[0.625rem] font-semibold leading-[1.1875rem] text-[--text-color]">
        {label}
      </span>
    </div>
  );
}
